<div
[fxLayout]="to?.['fxLayout'] ? to?.['fxLayout'] : 'row wrap'"
[fxLayoutGap]="to?.['fxLayoutGap']?to?.['fxLayoutGap']:'0px'">
  <formly-field [field]="f" *ngFor="let f of field.fieldGroup" [fxFlex]="f.props?.['fxFlex']">

  </formly-field>
</div>
